import { useEffect, useMemo, useRef } from 'react';
import { UseFormReturn, useFormState } from 'react-hook-form';
import { useFormStateIsDirty } from '../useFormStateIsDirty';
import { useFormCoordinatorContext } from './FormCoordinatorContext';
import { FormHandlerState } from './FormCoordinatorSubject';

interface ICoordinatedFormInput {
  id: string | null | undefined;
  methods: UseFormReturn;
}

/**
 * Registra il form all'interno del FormCoordinator
 */
export function useCoordinatedForm(form: ICoordinatedFormInput) {
  const { registerForm, unregisterForm } = useFormCoordinatorContext();

  // TODO Verificare se è necessario aggiornarli
  const methodsRef = useRef(form.methods);

  // Non possiamo usare `methods.formState` direttamente perché non
  // costringerebbe l'intero form (_ogni_ campo) al re-rendering
  const { isDirty: isTouched, isValid, dirtyFields } = useFormState();
  const isDirty = useFormStateIsDirty();

  /**
   * Calcola lo stato del form e provvede a registrarlo all'interno del
   * FormCoordinator
   */
  const coordinateState: FormHandlerState = useMemo(() => {
    // console.log(`[${String(form.id)} dirtyFields]`, isDirty, flattenDirtyFields(dirtyFields)); // prettier-ignore

    return {
      id: form.id!,
      /**
       * In realtà `isDirty` di react-hook-form si comporta più come un
       * `isTouched` e non come un `isDirty` vero e proprio, infatti
       * non è in sync con `dirtyFields`.
       */
      isTouched,
      isDirty,
      isValid,
      dirtyFields,
    };
  }, [form.id, isTouched, isDirty, isValid, dirtyFields]);

  useEffect(() => {
    if (!form.id || !registerForm) return;

    registerForm(methodsRef, coordinateState);
    return () => {
      if (form.id && unregisterForm) {
        unregisterForm(form.id);
      }
    };
  }, [form.id, registerForm, unregisterForm, coordinateState]);
}
